<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="Plate_title" :id="IdName ? '' : 'Plate_title'">
    <div class="text_title">
      {{ title }}
      <span>
        <slot name="title" />
      </span>
    </div>
    <div class="extra">
      <slot name="extra" />
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "IdName"],
  name: "Label",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
#Plate_title {
  padding-bottom: 14px;
  border-bottom: 1px solid #e9e9e9;
}
.Plate_title {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .text_title {
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    position: relative;
    padding-left: 20px;
  }
  .text_title::before {
    content: "";
    width: 4px;
    display: block;
    height: 16px;
    background: #0570ff;
    border-radius: 16px 16px 16px 16px;
    color: #0570ff;
    position: absolute;
    left: 0;
    top: 3px;
  }
}
</style>
